import {DG_axios} from "../../../../custom/axios";

const BASE_URL = `/dogoo/job-position-rest/v2.0/job-positions`;
const BASE_URL_LEAVE = `/dogoo/application-leave-reason-config-rest/v2.0/leave-reasons`;

export const loadJobPositionsApi = async (params) => {
    const config = {params: params};
    const response = await DG_axios.get(BASE_URL, config)
    return response.data || [];
}

export const loadReasonLeaveApi = async (params) => {
    const config = {params: params};
    const response = await DG_axios.get(BASE_URL_LEAVE, config)
    return response.data || [];
}
